module.exports = __webpack_public_path__ + "img/isometric-lego.53f18895.svg";